<template>
    <div>
      <form v-on:submit.prevent="addChatGPT">
        <div class="row">
            <div class="col-md-12">
                <label>Nama Bot</label>
                <input type="text" class="form-control" v-model="form.name" autofocus required />
                <br />
                <!-- <label> Device </label>
                    <multiselect v-model="selectedDevice" tag-placeholder="Pilih device"
                        placeholder="Pilih device" label="name" track-by="id" :options="device"
                        :multiple="false"></multiselect>
                <br> -->
            </div>
            <div class="col-md-12"  style="margin-top:10px">
                <label for="">Reenable Ai Duration (menit)</label>
                <input type="number" placeholder="" class="form-control" v-model="form.reenable_ai_duration" autofocus required />
                <i>*Waktu percakapan kembali di Respon AI, setelah user chat dengan cs asli / jika spam terdeteksi</i>
                <br>
                <label for="">Notif WhatsApp Admin saat AI Handover (Opsional)</label>
                <input type="text" placeholder="Contoh: 081234567890 atau 6281234567890" class="form-control" v-model="form.admin_notify_phone" />
                <i>*Nomor admin yang akan dapat WA notif saat AI handover ke CS manusia. Kosongkan = tidak dikirim notif.</i>
                <br>
                <input type="checkbox" id="disable-oot" class="checkbox" v-model="form.disable_oot" :true-value="1" :false-value="0">
                <label for="disable-oot">
                    <span class="checkbox-text" style="margin-left: 5px;">AI selalu coba respond <span class="badge badge-info">RECOMMENDED</span></span>
                </label>
                <br>
                <i>*Aktifkan supaya AI selalu mencoba menjawab walau pertanyaan tidak yakin nyambung. Default off (AI bisa silent kalau pertanyaan terlalu out-of-topic).</i>
                <hr>
                <div v-if="userRole === 'admin'" class="card thick-border" style="background:#fff8e1; border:2px dashed #ff9800; margin: 12px 0;">
                    <div class="card-body">
                        <h6 style="margin-top:0; color:#e65100;">🧾 INVOICE ADDON (KHUSUS BOT ADMIN)</h6>
                        <small class="form-text text-muted mb-2">
                            <i class="fas fa-info-circle"></i>
                            <b>Hanya aktifkan kalau bot ini melayani perpanjangan paket StarSender.</b>
                            User akan diminta email → bot otomatis generate invoice + PDF + kirim ke WA & email user.
                            Bukti transfer yang user kirim akan otomatis diforward ke nomor CS Admin di bawah.
                        </small>
                        <input type="checkbox" id="enable-invoice-addon" class="checkbox" v-model="form.enable_invoice_addon" :true-value="1" :false-value="0">
                        <label for="enable-invoice-addon">
                            <span class="checkbox-text" style="margin-left: 5px;">Aktifkan fitur Invoice Perpanjangan Paket</span>
                        </label>
                        <div v-if="form.enable_invoice_addon == 1">
                            <br>
                            <label>Nomor CS Admin Penerima Bukti Transfer</label>
                            <input type="text" v-model="form.cs_admin_phone" class="form-control" placeholder="Contoh: 6281319227392 (tanpa +)" />
                            <i style="font-size: 12px; color: #888;">*Nomor WA admin yang akan otomatis dapat forward bukti transfer dari user beserta detail invoice.</i>
                        </div>
                    </div>
                </div>
                <br>
                <br>
                <label>Delay Balas Pesan (detik)</label>
                <input type="number" placeholder="0" min="0" class="form-control" v-model="form.reply_delay" autofocus />
                <i>*Waktu delay sebelum AI membalas pesan (dalam detik)</i>
                <br>
                <br>
                <!-- <input name="hide" class="checkbox" type="checkbox" id="check-1" v-model="form.disable_during_office_hour">
                <label for="check-1">
                    <span class="checkbox-text" style="margin-left: 5px;">Disable During Office Hour</span>
                </label>
                <br> -->
                <input name="hide" class="checkbox" type="checkbox" id="check-2" v-model="form.enable_memory">
                <label for="check-2">
                    <span class="checkbox-text" style="margin-left: 5px;">Enable Memory</span>
                </label>
            </div>
        </div>
        <br>
        <div class="button-group d-flex pt-25">
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              Simpan
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
    //   import Multiselect from 'vue-multiselect'

  export default {
    props: ['form', 'id'],
    components: {
        },
    data() {
      return {
        device: [],
        selectedDevice: null,
        // form: {
        //     device: [],
        //     name: "",
        //     api_key: "",
        //     models: "gpt-4o-mini",
        //     enable_memory: false,
        //     max_token_chat: 128,
        //     max_token_number: 1024,
        //     max_token_day: 102400,
        //     temperature: 0.5,
        //     top_p: 0.5,
        //     disable_during_office_hour: false,
        //     fallback_message: "",
        //     reenable_ai_duration: 15,
        //     custom_prompt: "",
        // },
      };
    },
    mounted() {
        // this.form.daily_max_token_number = this.form.daily_max_token_number
        // this.form.daily_max_token_global = this.form.daily_max_token_global
        this.form.enable_memory = this.form.enable_memory == 1 ? true : false
        this.form.disable_during_office_hour = this.form.disable_during_office_hour == 1 ? true : false
 
        this.getDevice()
    },
    computed: {
            userRole() { return localStorage.getItem('role') || '' },
        },
        methods: {
        async getDevice(param) {
                let res = await this.$store.dispatch("device_list_all", param);
                this.device = res.data.data.devices

                let d = this.device.find(x => x.id == this.form.device_id)
                this.selectedDevice = d     
            },
            async addChatGPT() {
              try {
                  // Salin form agar mudah dimanipulasi
                  let request = { ...this.form };
                //   let old_device = this.form.device;

                  // Modifikasi request dengan data yang diperlukan
                  request.id = this.id;
                  request.device_id = this.selectedDevice?.id || null; // Pastikan ada fallback jika device.id tidak ada
                  request.enable_memory = request.enable_memory ? 1 : 0;
                  request.disable_during_office_hour = request.disable_during_office_hour ? 1 : 0;

                  // Pastikan parsing data aman
                  request.max_token_chat = parseInt(request.max_token_chat) || 0;
                  request.daily_max_token_number = parseInt(request.daily_max_token_number) || 0;
                  request.daily_max_token_global = parseInt(request.daily_max_token_global) || 0;
                  request.reenable_ai_duration = parseInt(request.reenable_ai_duration) || 0;
                  request.reply_delay = parseInt(request.reply_delay) || 0;
                  request.temperature = parseFloat(request.temperature) || 0.0;
                  request.top_p = parseFloat(request.top_p) || 0.0;

                  // Kirim request melalui Vuex action
                  let response = await this.$store.dispatch('chatgpt_update', request);

                  // Tampilkan pesan sukses
                  this.$toast.success(response.data.message);

                  // Kembalikan form.device ke nilai awal
                //   this.form.device = old_device;

                  // Jika diperlukan, aktifkan event berikut
                  // this.$root.$emit("toggle_modal", "new_bot");
                  // this.$root.$emit("refresh_table", true);
              } catch (err) {
                  // Tangani error dan tampilkan pesan
                  const errorMessage = err.response?.data?.message || 'Something went wrong';
                  this.$toast.error(errorMessage);
              }
        }
    },
  };
  </script>
  
